/**
 * Helper to convert PascalCase to snake_case, handling consecutive capitals
 * @param {string} str
 * @returns {string}
 * @example
 * pascalToSnake('IconPrinterWarningAlt') // 'icon_printer_warning_alt'
 * pascalToSnake('IconQRCode') // 'icon_qr_code'
 */
export const pascalToSnake = (str) => {
  let result = ''
  for (let i = 0; i < str.length; i++) {
    const char = str[i]
    if (
      i > 0 &&
      /[A-Z]/.test(char) &&
      (/[a-z]/.test(str[i - 1]) ||
        (i + 1 < str.length && /[a-z]/.test(str[i + 1])))
    ) {
      result += '_'
    }
    result += char
  }
  return result.toLowerCase()
}
